import query from "../query";
import { BetType } from "../types/common";

type Sport =
  | "football"
  | "basketball"
  | "volleyball"
  | "tabletennis"
  | "handball"
  | "icehockey"
  | "tennis"
  | "snooker"
  | "baseball"
  | "rugby"
  | "cricket"
  | "americanfootball"
  | "badminton"
  | "boxing"
  | "bull_fight"
  | "cock_fight";

type TableType = "today" | "live" | "early";

export const getSportQueryKey = (
  sport: Sport,
  type: TableType,
  betType: BetType,
  provider?: string,
) => {
  switch (sport) {
    case "badminton":
      return query.badmintonFeed(type, betType).key;
    case "americanfootball":
      return query.americanfootballFeed(type, betType).key;
    case "rugby":
      return query.rugbyFeed(type, betType).key;
    case "baseball":
      return query.baseballFeed(type, betType).key;
    case "snooker":
      return query.snookerFeed(type, betType).key;
    case "tennis":
      return query.tennisFeed(type, betType).key;
    case "icehockey":
      return query.icehockeyFeed(type, betType).key;
    case "handball":
      return query.handballFeed(type, betType).key;
    case "tabletennis":
      return query.tabletennisFeed(type, betType).key;
    case "basketball":
      return query.basketballFeed(type, betType, provider).key;
    case "volleyball":
      return query.volleyballFeed(type, betType).key;
    case "cricket":
      return query.cricketFeed(type).key;
    case "boxing":
      return query.boxingFeed(type).key;
    case "bull_fight":
      return query.bullfightFeed(type).key;
    case "cock_fight":
      return query.cockfightFeed(type).key;
    default:
      return query.footballFeed(type, betType, provider).key;
  }
};
